import { db } from '../firebase/config';
import { doc, updateDoc, setDoc, serverTimestamp, addDoc, collection, getDoc } from 'firebase/firestore';
import { unlockAssessmentForUser } from './assessmentService';

export async function logAdminAction(actionType, adminId, targetUserId, details = {}) {
  await addDoc(collection(db, 'adminActions'), {
    type: actionType,
    adminId,
    targetUserId: targetUserId || null,
    details,
    createdAt: serverTimestamp()
  });
}

export async function onboardUser(adminId, userId) {
  await unlockAssessmentForUser(userId, adminId, 'admin_onboard');
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, {
    dashboardUnlocked: false,
    onboardingStatus: 'pending',
    onboardingUpdatedAt: serverTimestamp()
  });
  await logAdminAction('onboard_user', adminId, userId, {});
}

export async function getUserProfile(userId) {
  const ref = doc(db, 'users', userId);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export default {
  logAdminAction,
  onboardUser,
  getUserProfile
};
